import React from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';

export type LzTRouteEntry = {
  path: string;
  element: React.ReactNode;
  elementAdd?: React.ReactNode;
  elementEdit?: React.ReactNode;
  elementView?: React.ReactNode;
};

export type LzTRouteEntries = LzTRouteEntry[];

/**
 * Build router and return as react node.
 * 
 * @param routes LzTRouteEntries
 *
 * @returns React.ReactNode
 */
export const lzFBuildRouter = (routes: LzTRouteEntries): React.ReactNode => {
  return (
    <Router>
      <Routes>
        {routes.map((route: LzTRouteEntry, dex) => {
          const hasAdd = typeof route.elementAdd !== 'undefined';
          const hasEdit = typeof route.elementEdit !== 'undefined';
          const hasView = typeof route.elementView !== 'undefined';
          if (hasAdd || hasEdit || hasView) {
            return (
              <Route key={'route-' + dex} path={route.path}>
                <Route index element={route.element} />
                {hasAdd && (
                  <React.Fragment>
                    <Route path='add' element={route.elementAdd} />
                    <Route path='add/:id' element={route.elementAdd} />
                  </React.Fragment>
                )}
                {hasEdit && (
                  <Route path=':id/edit' element={route.elementEdit} />
                )}
                {hasView && (
                  <Route path=':id/view' element={route.elementView} />
                )}
              </Route>
            );
          } else {
            return (
              <Route
                key={'route-' + dex}
                path={route.path}
                element={route.element}
              />
            );
          }
        })}
      </Routes>
    </Router>
  );
};

